import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { COLOR_INPUT_STYLE } from "../constants";

export default function CanvasPanel({ canvasBg, setCanvasBg, canvasSize }) {
    return (
        <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                Cliquez sur un élément pour le modifier, ou configurez le canvas ci-dessous.
            </Typography>

            <Divider sx={{ mb: 1.5 }} />

            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                Canvas : {canvasSize.width} × {canvasSize.height} px
            </Typography>

            <Box sx={{ mt: 1.5 }}>
                <Typography variant="caption" color="text.secondary">Couleur de fond</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                    <input
                        type="color"
                        value={canvasBg}
                        onChange={e => setCanvasBg(e.target.value)}
                        style={COLOR_INPUT_STYLE}
                    />
                    <Typography variant="body2">{canvasBg}</Typography>
                </Box>
            </Box>
        </Box>
    );
}
